import { ConfirmCancelModal } from '@/shared/components/ConfirmCancelModal'

interface Props {
  open: boolean
  onClose: () => void
  memberName?: string
  onConfirm?: () => void
  isPending?: boolean
}

export function DeactivateMemberModal({
  open,
  onClose,
  memberName,
  onConfirm,
  isPending = false,
}: Readonly<Props>) {
  const displayName = memberName?.trim() || 'this team member'

  return (
    <ConfirmCancelModal
      open={open}
      headline="Deactivate Team Member"
      bodyLines={[
        `Are you sure you want to deactivate ${displayName}? They will be immediately removed from all assigned campaigns and their session will be terminated.`,
        '',
      ]}
      stayLabel="Cancel"
      confirmLabel="Yes, Confirm Deactivation"
      confirmTone="danger"
      confirmDisabled={isPending}
      disableEscapeKeyDown={isPending}
      onStay={onClose}
      onConfirm={() => onConfirm?.()}
      dialogTestId="deactivate-member-dialog"
    />
  )
}
